import { render, staticRenderFns } from "./digital-flotilla.vue?vue&type=template&id=035e3264&scoped=true"
import script from "./digital-flotilla.vue?vue&type=script&lang=js"
export * from "./digital-flotilla.vue?vue&type=script&lang=js"
import style0 from "./digital-flotilla.vue?vue&type=style&index=0&id=035e3264&prod&lang=scss"
import style1 from "./digital-flotilla.vue?vue&type=style&index=1&id=035e3264&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035e3264",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VImg: require('/var/www/tubber-new/components/global/v/img.vue').default,VButton: require('/var/www/tubber-new/components/global/v/button.vue').default,VBreadcrumbs: require('/var/www/tubber-new/components/global/v/breadcrumbs.vue').default})
